import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import _ from 'lodash';
import { toDateFormat } from 'utils/date';
import WorkoutHistoryList from './WorkoutHistoryList';

class WorkoutHistoryAccordion extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      activeKeys: {},
      groupedWorkoutLogs: this.prepareWorkoutLogs(props.workoutLogs)
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.workoutLogs !== this.props.workoutLogs){
      this.setState({
        groupedWorkoutLogs: this.prepareWorkoutLogs(nextProps.workoutLogs)
      });
    }
  }

  prepareWorkoutLogs = workoutLogs => {
    workoutLogs.sort((log1, log2) => {
      return log2.name - log1.name ;
    })
    let groupedWorkoutLogs = _.groupBy(workoutLogs, 'name');
    Object.keys(groupedWorkoutLogs).forEach((key) => {
      groupedWorkoutLogs[key].sort((log1, log2) => {
        return toDateFormat(log2.created_at) - toDateFormat(log1.created_at) ;
      })
    })

    return groupedWorkoutLogs;
  }

  prepareWorkoutLogsCards = () => {
    let { groupedWorkoutLogs, activeKeys } = this.state;
    let cards = [];
    Object.keys(groupedWorkoutLogs).forEach((key, index) => {
      let cardKey = groupedWorkoutLogs[key][0].id;
      let logsList = groupedWorkoutLogs[key];
      cards.push(
        <Accordion defaultActiveKey={0} key={index} >
          <Card key={index}>
            <Accordion.Toggle
              as={Card.Header}
              eventKey={cardKey}
              onClick={e => {
                let { activeKeys } = this.state;
                let newActiveKeys = { ...activeKeys };
                newActiveKeys[`${cardKey}`] = !activeKeys[`${cardKey}`];
                this.setState({activeKeys: { ...newActiveKeys }});
              }}
            >
              {key}, {logsList[0].level} Phase {logsList[0].phase}
              <i className={(!!activeKeys[`${cardKey}`]) ? `fas fa-sort-down` : `fas fa-sort-up`}></i>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey={cardKey}>
              <Card.Body>
                <WorkoutHistoryList logsList={logsList} clientId={this.props.clientId}/>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      );
    })
    return cards;
  }

  render() {
    return (
      <> {this.prepareWorkoutLogsCards()} </>
    );
  }
}

export default WorkoutHistoryAccordion;
